// extracted by mini-css-extract-plugin
export default {"invalidDataError":"Rolepermission_invalidDataError__BtmbU"};